export const Key = {
    _down:{},
    _pressed: {},
    _released: {},
    _keyboardDown: {},
    _gamepadDown: {},
    _levelDown: {},
    BACKPACE:8,
    TAB:9,
    ENTER:13,
    SHIFT:16,
    CTRL:17,
    ALT:18,
    ESCAPE:27,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    DELETE:46,
    0:48,
    1:49,
    2:50,
    3:51,
    4:52,
    5:53,
    6:54,
    7:55,
    8:56,
    9:57,
    A: 65,
    B: 66,
    C: 67,
    D: 68,
    E: 69,
    F: 70,
    G: 71,
    H: 72,
    I: 73,
    J: 74,
    K: 75,
    L: 76,
    M: 77,
    N: 78,
    O: 79,
    P: 80,
    Q: 81,
    R: 82,
    S: 83,
    T: 84,
    U: 85,
    V: 86,
    W: 87,
    X: 88,
    Y: 89,
    Z: 90,
    COMMAND:91,
    MOUSE:1000,
    SPACE:32,
    SLASH: 191,
    isDown: function (keyCode, source) {
        const down = source === 'keyboard' ? this._keyboardDown : source === 'gamepad' ? this._gamepadDown : this._down;
        if(keyCode instanceof Array){
            var i;
            for(i = 0; i<keyCode.length; i++){
                if(!down[keyCode[i]]) return false;
            }
            return true;
        }else{
            return down[keyCode];
        }
    },

    isReleased: function (keyCode){
        return this._released[keyCode];
    },
    isPressed: function (keyCode){
        return this._pressed[keyCode];
    },

    setKey: function (keyCode, down, source = 'keyboard') {
        const held = source === 'level' ? this._levelDown : source === 'gamepad' ? this._gamepadDown : this._keyboardDown;
        if(down) held[keyCode] = true;
        else delete held[keyCode];
        const combined = this._keyboardDown[keyCode] || this._gamepadDown[keyCode] || this._levelDown[keyCode];
        if(combined) {
            if(!this._down[keyCode]) this._pressed[keyCode] = true;
            this._down[keyCode] = true;
        } else if(this._down[keyCode]) {
            delete this._down[keyCode];
            this._released[keyCode] = true;
        }
    },

    // A lost keyup leaves a modifier held (macOS drops keyups around Command shortcuts), but every
    // key and mouse event says which modifiers are still down.
    syncModifiers: function (event) {
        if (event.shiftKey === false && this._keyboardDown[16]) this.setKey(16, false);
        if (event.altKey === false && this._keyboardDown[18]) this.setKey(18, false);
        if (event.ctrlKey === false && this._keyboardDown[17]) this.setKey(17, false);
        if (event.metaKey === false) [91, 93, 224].forEach(code => this._keyboardDown[code] && this.setKey(code, false));
    },
    onKeydown: function (event) {
        this.syncModifiers(event);
        this.setKey(event.keyCode, true);

        if(event.keyCode == 91){
            //fix command
            this.setKey(93, true);
            this.setKey(224, true);
        }
    },

    onKeyUp: function (event) {
        this.syncModifiers(event);
        this.setKey(event.keyCode, false);
        if([93, 91, 224].includes(event.keyCode)){
            // macOS may omit keyup for keys held with Command. Clear that
            // keyboard state without releasing keys still held by a controller.
            for(const code of Object.keys(this._keyboardDown)) this.setKey(code, false);
        }
    },
    setGamepadKeys: function (keys) {
        for(const code of Object.keys(this._gamepadDown)) {
            if(!keys.has(Number(code))) this.setKey(code, false, 'gamepad');
        }
        for(const code of keys) this.setKey(code, true, 'gamepad');
    },
    onMouseDown: function(event) {
        if(event) this.syncModifiers(event);
        this.onKeydown({keyCode:Key.MOUSE});
    },
    onMouseUp: function(event) {
        if(event) this.syncModifiers(event);
        this.onKeyUp({keyCode:Key.MOUSE});
    },

    update: function (){
        this._pressed = {};
        this._released = {};
    },
    reset: function(){
        this._keyboardDown = {};
        this._gamepadDown = {};
        this._levelDown = {};
        this._down = {};
        this.update();
    },
};

export const KeyNames = [
    'ENTER',
    'SHIFT',
    'CTRL',
    'ALT',
    'LEFT',
    'UP',
    'RIGHT',
    'DOWN',
    'DELETE',
    'COMMAND',
    'SPACE',
    'SLASH',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'Q',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
]

export const KeyboardEventKeys = {
    ENTER: 'Enter',
}

export const KeyValLookup = {};
KeyNames.forEach( key => {
    const val = Key[key];
    KeyValLookup[val] = key;
})

// custom name keys
